import styled from 'styled-components';
import Close from '@catalogo/ui-americanas-desktop-svg/close.svg';

interface FilterTagStyledProps {
  fontSize: number;
}

const FilterTagStyled = styled.span<FilterTagStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border: 1px solid #666666;
  border-radius: 24px;
  color: #666666;
  font-size: ${({ fontSize }) => fontSize}px;

  :hover {
    cursor: pointer;
  }
`;

const IconClose = styled(Close)`
  margin-left: 6px;
  width: 16px;
  height: 16px;
`;

export default FilterTagStyled;
export { FilterTagStyled, IconClose };
